// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__HvDAh","tabs_header":"Tabs_tabs_header__nJovP","tabs_header_selected":"Tabs_tabs_header_selected__1r5bt"};